export default __webpack_public_path__ + "7991c9daf8720977b686a177db95f4d5.png";